<template>
  <HeaderComponent/>
  <a href="#" id="back_button" style="font-size: 20px; color: black; margin-left: 4vw;" @click="this.$router.go(-1)">
    Назад
  </a>
  <div id="wrapper">
    <MenuComponent/>
    <div class="form-check-inline" style="width: 30vw">
      <h3>Изменение данных</h3>
      <div class="form-group">
        <label><b>Контактное лицо</b></label>
        <input class="form-control" type="text"
               v-model="this.user['contact_person']"/>
      </div>

      <div class="form-group">
        <label><b>Должность</b></label>
        <input class="form-control" type="text"
               v-model="this.user['position']"/>
      </div>

      <div class="form-group">
        <label><b>Телефон</b></label>
        <input class="form-control" type="text" v-model="this.user['phone']"/>
      </div>
      <button class="btn btn-success mt-3" @click="update_user_info">
        Подтвердить изменения
      </button>
    </div>
  </div>
  <FooterComponent/>
</template>

<script>
import HeaderComponent from "@/customer/HeaderComponent";
import MenuComponent from "@/customer/MenuComponent";
import FooterComponent from "@/customer/FooterComponent";
import axios from "axios";

export default {
  name: "CustomerProfileEdit",

  components: {HeaderComponent, MenuComponent, FooterComponent},

  data() {
    return {
      user: {}
    }
  },

  methods: {
    get_user() {
      axios.post("/api/customer/profile", {
            "token": localStorage.getItem("access_token"),
          }, {
            headers: {
              'Accept':
                  'application/json',
              'Content-Type':
                  'application/json'
            }
          }
      ).then((response) => this.user = response.data)
    },

    update_user_info() {
      axios.post("/api/customer/update_profile", {
            "token": localStorage.getItem("access_token"),
            "contact_person": this.user['contact_person'],
            "position": this.user['position'],
            "phone": this.user['phone'],
          }, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          }
      ).then((response) => {
        if (response.status === 200) {
          alert("Данные успешно обновлены!")
        }
      })
    },
  },

  mounted() {
    this.get_user()
  }
}
</script>

<style scoped>
#wrapper {
  font-family: Ubuntu;
  display: flex;
  margin-left: 4vw;
  margin-top: 2vh;
  min-height: 85vh;
}
</style>